import { render } from "./solicitudCard.vue?vue&type=template&id=aebbc1e0&scoped=true"
import script from "./solicitudCard.vue?vue&type=script&lang=js"
export * from "./solicitudCard.vue?vue&type=script&lang=js"

import "./solicitudCard.vue?vue&type=style&index=0&id=aebbc1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebbc1e0"]])

export default __exports__